import { connect } from "react-redux";
import ManageProjectPMSlot from "./manageProjectPMSlot";
import { bindActionCreators } from "redux";
import {fetchPmAssignee,postScheduleProjectPM,fetchProjectPmSlotDetails} from "services/redux/maintenance/pmTicket/action";
const mapStateToProps = (state) => ({
  pmAssigneeList: state.pmTicketReducer.pmAssigneeList,
  projectPmSlotDetails: state.pmTicketReducer.projectPmSlotDetails
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPmAssignee,
      postScheduleProjectPM,
      fetchProjectPmSlotDetails
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ManageProjectPMSlot);
